import React, { FC, useState } from 'react';
import { useTranslate } from 'react-admin';
import { EditForm } from '../ra';
import Drawer from '~/components/Drawer';
import EditButton from '~/components/EditButton';
import AccountExternalLinkForm from './AccountExternalLinkForm';
import { AccountExternalLink } from '~/types/AccountExternalLink';
import { useClearAccountExternalLinksCache } from '~/hooks/accountExternalLinks';
import { FormDataConsumer } from 'react-admin';

const label = (key: string): string => `components.AccountExternalLinks.${key}`;

interface Props {
  profileId: string;
  profileType: string;
  accountId: string;
  link: AccountExternalLink;
}

const EditAction: FC<Props> = (props) => {
  const { profileId, profileType, accountId, link } = props;
  const clearExternalAccountLinksCache = useClearAccountExternalLinksCache(accountId);

  const translate = useTranslate();
  const t = (key: string): string => translate(label(key));

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <EditButton onClick={handleOpen} />
      <Drawer heading={t('editDrawerTitle')} open={open} onClose={handleClose}>
        <EditForm
          record={link}
          resource='externalAccountLinks'
          closeParent={handleClose}
          onSuccess={() => {
            clearExternalAccountLinksCache();
          }}
        >
          <FormDataConsumer>
            {({ formData }: any) => {
              return (
                <AccountExternalLinkForm
                  profileId={profileId}
                  profileType={profileType}
                  accountId={accountId}
                  // link={link}
                  edit
                  formData={formData}
                />
              );
            }}
          </FormDataConsumer>
        </EditForm>
      </Drawer>
    </>
  );
};

export default EditAction;
